var $ = require('jquery');
var Fancyapps = require('@fancyapps/ui');

module.exports = {
    init: function () {
        this.loadHandlers();
    },
    pluralCount: 1,
    activateFromSelect: function(target){
        if(target.value){
            //Fancyapps.Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
            this.highlightRegionFromCounty(target.value);
        }
    },
    activateFromClick: function(target){
        let county = $(target).attr('id');
        this.highlightRegionFromCounty(county);
    },    
    highlightRegionFromCounty: function(county){
        $('#ky-map').addClass('active');
        let groupEl = $('#' + county).parent();
        let groupId = groupEl.attr('id');
        let centerPlural = $('.location-' + groupId).length > 1 ? 's' : '';
        groupEl.addClass('highlight');
        $('.location-' + groupId).show();
        $('.map__result').addClass('active');
        $('#location-label').show();
        $('#location-label').text(county + " County's Local Center" + centerPlural);
    },
    resetMap: function(){
        $('#ky-map').removeClass('active');
        $('#ky-map g').removeClass('highlight');
        $('.map__result .location').hide();
        $('.map__result').removeClass('active');
        $('#location-label').hide();
    },
    loadHandlers: function(){
        $('.county-filter-select').on('change', (event) => {
            // Remove any class from previous change
            this.resetMap();
            this.activateFromSelect(event.target);
        });
        $('#ky-map path').on('click', (event) => {
            this.resetMap();
            this.activateFromClick(event.target);
        });
        $(document).on('click', (event) => {
            // If the click was not on map, dropdown or location box, reset map
            if(
                !$(event.target).parents('#ky-map').length > 0 &&
                !$(event.target).parents('.location').length > 0 &&
                !$(event.target).hasClass('county-filter-select')
            ){
                this.resetMap();
            }
        });
    }
}